<template>
  <div class="container">
    <!-- <h4 class="text-2xl text-center mb-2">Forma za prijavu</h4> -->
    <p class="italic text-center">
      Imate li pitanja o implementaciji fotonaponske solarne elektrane ili Vam
      treba vam stručan savjet, obratite se našem timu. Naši će vam stručnjaci
      osposobljeni za implementaciju i nadzor fotonaponskih solarnih elektrana
      odgovoriti na sva pitanja u što kraćem roku.
    </p>

    <form
      class="d-flex flex-col w-full max-w-sm lg:max-w-md mt-8 md:mt-16 mx-auto"
      spellcheck="false"
    >
      <div class="form-group required mb-4">
        <label for="name">Naziv tvrtke:</label>
        <input type="text" id="name" class="form-control" v-model="form.name" />
      </div>

      <div class="form-group required mb-4">
        <label for="full_name">Ime i Prezime:</label>
        <input
          type="text"
          id="full_name"
          class="form-control"
          v-model="form.full_name"
        />
      </div>

      <div class="flex flex-wrap md:-mx-2 mb-4">
        <div class="w-full md:w-1/2 md:px-2 mb-4 md:mb-0">
          <div class="form-group required">
            <label for="email">E-mail adresa:</label>
            <input
              type="text"
              id="email"
              class="form-control"
              v-model="form.email"
            />
          </div>
        </div>

        <div class="w-full md:w-1/2 md:px-2">
          <div class="form-group">
            <label for="contact">Kontakt broj:</label>
            <input
              type="text"
              id="contact"
              class="form-control"
              v-model="form.contact"
            />
          </div>
        </div>
      </div>

      <div class="form-group required mb-4">
        <label for="area_of_interest">Područje interesa:</label>
        <input
          type="text"
          id="area_of_interest"
          class="form-control"
          v-model="form.area_of_interest"
        />
      </div>

      <div class="form-group required mb-4">
        <label for="enquiry">Vaš upit:</label>
        <textarea
          id="enquiry"
          class="form-control"
          v-model="form.enquiry"
          rows="4"
        ></textarea>
      </div>

      <div class="form-group required checkbox-control mb-4">
        <input
          id="gdpr"
          type="checkbox"
          class="form-control"
          v-model="form.gdpr"
        />
        <label for="gdpr">
          <strong>Privola:</strong> Vaše osobne podatke prikupljamo i obrađujemo
          isključivo u svrhu povratnog kontakta kako bismo odgovorili na Vaš
          upit.
          <br />
          <router-link
            class="text-secondary underline"
            target="_blank"
            :to="{ name: 'gdpr' }"
            >Politika privatnosti</router-link
          >
        </label>
      </div>

      <div class="form-group items-center mt-6">
        <button
          type="button"
          class="bg-primary active:bg-body hover:bg-body text-gray-900 text-base font-bold italic uppercase rounded-lg py-4 px-12 md:py-6 md:px-18 lg:py-8 lg:px-24"
          @click.prevent="submit"
          :disabled="isProcessing"
        >
          <span v-html="isProcessing ? 'Slanje u tijeku...' : 'Pošalji'"></span>
        </button>
        <input type="hidden" v-model="form.token" />
      </div>
    </form>

    <transition name="reveal">
      <div
        class="alert"
        :class="`alert-${response.status}`"
        ref="alert"
        v-if="response.status"
      >
        <p v-html="response.message"></p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    //
  },

  beforeMount() {
    this.$recaptchaLoaded().then(() => {
      this.recaptcha();
    });
  },

  data() {
    return {
      //   active: false,
      form: {
        // subject: "",
        name: "",
        full_name: "",
        email: "",
        contact: "",
        area_of_interest: "",
        enquiry: "",
        gdpr: false,
        token: "",
      },
      isProcessing: false,
      endpoint: process.env.API_LOCAL + "/solar.php",
      response: {
        status: "",
        message: "",
      },
      responseTimer: null,
      responseDuration: 5000,
    };
  },

  updated() {
    // this.form.subject = this.job.title;
  },

  methods: {
    submit() {
      this.isProcessing = true;

      let data = new FormData();

      _.forEach(this.form, (val, key) => {
        data.append(key, val);
      });

      this.$api
        .post("/solar.php", data, {
          header: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.setMessage("success", response.data.message);

          this.resetForm();
          this.isProcessing = false;
        })
        .catch((error) => {
          let message = "";

          console.log(error.response);
          console.log(error.response.data);

          if (!error.response || !error.response.data) {
            message = "Došlo je do greške!";
          } else {
            message = error.response.data.message;
          }

          this.setMessage("danger", message);

          this.$nextTick(() => {
            this.recaptcha();
            this.isProcessing = false;
          });
        });
    },

    resetForm() {
      this.form.name = "";
      this.form.full_name = "";
      this.form.email = "";
      this.form.contact = "";
      this.form.area_of_interest = "";
      this.form.enquiry = "";
      this.form.gdpr = false;

      this.recaptcha();
    },

    setMessage(status, message) {
      if (this.responseTimer !== null) {
        clearTimeout(this.responseTimer);
      }

      this.response.status = status;
      this.response.message = message;

      this.responseTimer = setTimeout(() => {
        this.response.status = null;
        this.response.message = "";
      }, this.responseDuration);
    },

    recaptcha() {
      this.$recaptcha("homepage")
        .then((token) => {
          this.form.token = token;
        })
        .catch((error) => {
          console.error("Invalid recaptcha token");
        });
    },
  },
};
</script>
